// Vendor imports
const { connect } = require('react-redux')
// Shared imports
const { formatCount, pluralize } = require('shared/string-utils')
// Common client-v2 imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const articleModelConnect = require('client-v2/common/models/article/connect')
const userModelActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container state imports
const { getSlide } = require('../state/selectors')
const articleProfileSlideActions = require('../state/slide-actions')
const { TabNameEnum } = require('../state/slide-record')
// Sibling imports
const ArticleProfileDetailCard = require('./detail-card-dumb')

const Collections = pluralize('Collection')
const Comments = pluralize('Comment')
const Interests = pluralize('Interest')

function mapStateToProps() {
  return function (state, props) {
    const slide = getSlide(state, props)
    return {
      article: slide.article,
      curatedAt: slide.curatedAt,
      curatedBy: slide.curatedBy,
      tabs: {
        [TabNameEnum.COLLECTIONS]: collectionsTabState(slide),
        [TabNameEnum.COMMENTS]: commentsTabState(slide),
        [TabNameEnum.INTERESTS]: interestsTabState(slide)
      },
      user: state.user
    }
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    ...articleModelConnect.mapDispatchToProps(dispatch),
    onTabSelect: dispatchAction(articleProfileSlideActions.selectTab),
    onUserNavigate: dispatchAction(userModelActions.navigateToUserProfile)
  }
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    ArticleProfileDetailCard
  )
)

module.exports = SmartComponent

// Internal state helpers

function collectionsTabState(slide) {
  const { count } = slide.article
  const isLoading = slide.collectionsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Collections'
  : `In ${formatCount(count)} ${Collections(count)}`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.COLLECTIONS,
    label
  }
}

function commentsTabState(slide) {
  const count = slide.commentsItems.size
  const isLoading = slide.commentsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Comments'
  : `${formatCount(count)} ${Comments(count)}`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.COMMENTS,
    label
  }
}

function interestsTabState(slide) {
  const count = slide.interestsItems.size
  const isLoading = slide.interestsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Interests'
  : `${formatCount(count)} ${Interests(count)}`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.INTERESTS,
    label
  }
}
